import { FC, ReactNode } from 'react';
import { LegalContextProps } from './legal.context';
import LegalMain from './legal.main';

interface LegalWrapperProps extends LegalContextProps {
  children: ReactNode;
}

export const LegalWrapper: FC<LegalWrapperProps> = ({ children, ...contextProps }) => {
  return <LegalMain {...contextProps}>{children}</LegalMain>;
};
